import { createElement, useCallback, useState, useEffect } from 'react';
import { ListDesign, ListItem } from '../';
import { isNullish } from '@sas/nova-core/typeguards';
import { MultiListProps } from './';

/**
 * @deprecated
 * Please use List instead.
 */
export const MultiList = (props: MultiListProps) => {
  const onSelected = useCallback(
    ({ index: selectIndex }: { index: number }): void => {
      setFocusedIndex(selectIndex);
      const selected = [];
      if (props.selectedIndices) selected.push(...props.selectedIndices);
      {
        const index = selected.indexOf(selectIndex);
        if (index >= 0) {
          selected.splice(index, 1);
        } else {
          selected.push(selectIndex);
        }
      }
      const onSelected = props.onSelected;
      onSelected?.(new Set(selected));
    },
    [props.onSelected, props.selectedIndices]
  );

  const [focusedIndex, setFocusedIndex] = useState<number | null | undefined>(undefined);

  useEffect(() => setFocusedIndex(undefined), [props.items?.length]);

  return (
    <ListDesign
      className={props.className}
      style={props.style}
      testId={props.testId}
      font={props.font}
      theme={props.theme}
      setFocusedIndex={setFocusedIndex}
      onSelectFocusedItem={() => {
        const selected: number[] = [];
        if (props.selectedIndices) selected.push(...props.selectedIndices);
        if (!isNullish(focusedIndex)) {
          const index = selected.indexOf(focusedIndex);
          if (index >= 0) {
            selected.splice(index, 1);
          } else {
            selected.push(focusedIndex);
          }
        }
        props.onSelected?.(new Set(selected));
      }}
      focusable={false}
      ariaLabel={props.ariaLabel}
    >
      {props.items?.map((item, index) => (
        <ListItem
          {...item}
          selected={props.selectedIndices ? props.selectedIndices.has(index) : false}
          focused={focusedIndex === index}
          focusable={index === (focusedIndex ?? 0)}
          onFocus={
            isNullish(focusedIndex) && index === 0
              ? () => {
                  setFocusedIndex(0);
                }
              : undefined
          }
          key={index}
          index={index}
          concatSecondaryText={props.concatSecondaryText}
          displayMode="checkbox"
          onSelected={onSelected}
        />
      ))}
    </ListDesign>
  );
};
